import { useState, useCallback } from 'react'
import { useDebounce } from './useDebounce'

// TODO: Add reset functionality
export const useSearch = (initialValue = '', debounceDelay = 300) => {
  const [searchTerm, setSearchTerm] = useState(initialValue)
  const debouncedSearchTerm = useDebounce(searchTerm, debounceDelay)

  const handleSearchChange = useCallback(eventOrValue => {
    const value = typeof eventOrValue === 'string' ? eventOrValue : eventOrValue.target.value
    setSearchTerm(value)
  }, [])

  return {
    searchTerm,
    debouncedSearchTerm,
    onSearchChange: handleSearchChange,
  }
}
